/**
 * Trigger-shot detection by medication name.
 *
 * The API doesn't (yet) expose a `medicationRole` field, so the frontend
 * uses well-known trigger-medication names to flag and visually mark
 * trigger shots. Covers the common cases: recombinant hCG (Ovidrel /
 * Ovitrelle), urinary hCG (Pregnyl / Novarel), generic hCG mentions, and
 * Lupron / leuprolide when used as an agonist trigger.
 *
 * Heuristic — may produce false positives for Lupron used in a long
 * protocol (where it's a downregulator, not a trigger). Acceptable given
 * the alternative is no marker at all.
 */
const TRIGGER_MED_PATTERN =
  /ovidrel|ovitrelle|pregnyl|novarel|choriogonadotropin|hcg|leuprolide|lupron|gonapeptyl|decapeptyl|triptorelin/i;

export function isTriggerMedicationName(
  name: string | null | undefined,
): boolean {
  if (!name) return false;
  return TRIGGER_MED_PATTERN.test(name);
}
